import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// Import translations for all available languages

const messages = {};

// Create a new vuei18n object with the locale and all messages.
const i18n = new VueI18n({
    locale: 'en',
    messages,
});

const keyNotFound = '%%KEY_NOT_FOUND%%';
i18n.missing = (locale, key, vm, values) => {
    // Based on vue18n parseArgs(...) function
    // values is either: [], [ args(obj) ] or [ locale(string), args(obj) ]
    const args = (typeof values[0] === 'string' ? values[1] : values[0]) || {};
    const fallback = args.i18nFallback !== undefined ? args.i18nFallback : keyNotFound;
    if (!fallback) {
        console.warn(`[languages] Using locale string '${key}' without fallback`);
    }

    const section = key.includes('.') ? key.slice(0, key.indexOf('.')) : key;
    const localeData = i18n.messages[locale];
    // Is undefined if the language has not started downloading yet
    if (localeData) {
        const sectionData = localeData[section];
        if (!sectionData) {
            console.warn(`[languages] Section not loaded '${section}'`);
        } else if (!sectionData._loading) {
            console.error(`[languages] Unknown key '${key}' in language '${locale}'!`);
            return fallback;
        }
    }

    // Apply text templating (e.g. "hi {name}!")
    return i18n.formatter.interpolate(fallback, args, key).join('');
};

export default i18n;
